import { render, staticRenderFns } from "./ExistingUserRegistrationPage.vue?vue&type=template&id=12a9ba56"
import script from "./ExistingUserRegistrationPage.vue?vue&type=script&lang=js"
export * from "./ExistingUserRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports